TYPE_STATIC_ROYAL